<template>
    <div id="login" class="wrapper-page">
        <div class="m-t-30 card card-body">
            <div class="text-center mb-3">
                <h1 class="text-uppercase font-bold">ATLAS</h1>
                <img width="140" alt="pen" :src="penSVG">
            </div>
            <div class="p-2">
                <ValidationObserver ref="formObserver" v-slot="{ invalid }">
                    <form class="form-horizontal" @submit.prevent="login">
                            <div class="form-group">
                                <div class="col-12">
                                    <ValidationProvider ref="emailInput" v-slot="{ errors, classes }">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fa fa-at"/>
                                                </span>
                                            </div>
                                            <input v-model="email" class="form-control" :class="classes" type="email"
                                                   required :placeholder="$t('Login.email')">
                                        </div>
                                        <ul v-if="errors[0]" class="parsley-errors-list filled">
                                            <li v-for="error of errors" :key="error" class="parsley-required">
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </ValidationProvider>
                                </div>
                            </div>
                        <div class="form-group">
                            <div class="col-12">
                                <ValidationProvider v-slot="{ errors, classes }">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="fa fa-lock"/>
                                            </span>
                                        </div>
                                        <input v-model="password" class="form-control" type="password" required minlength="5"
                                               :placeholder="$t('Login.password')" :class="classes">
                                    </div>
                                    <ul v-if="errors[0]" class="parsley-errors-list filled">
                                        <li v-for="error of errors" :key="error" class="parsley-required">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-12 text-center">
                                <div v-tooltip="$t('Login.byRememberingYou')" class="checkbox checkbox-custom">
                                    <input v-model="rememberMe" ref="passwordInput" id="checkbox-signup" type="checkbox">
                                    <label for="checkbox-signup">
                                        {{ $t("Login.rememberMe") }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="form-group text-center m-t-30">
                            <div class="col-12">
                                <SubmitBtn classes="btn btn-custom btn-bordred btn-block waves-effect waves-light text-uppercase"
                                    :loading="loading" :disabled="invalid" :text="$t('Login.login')"/>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import SubmitBtn from "../shared/forms/SubmitBtn";
import penSVG from "../../assets/svg/pen.svg";

export default {
    name: "Login",
    components: {SubmitBtn},
    data() {
        return {
            loading: false,
            email: "",
            password: "",
            rememberMe: false,
            penSVG,
        };
    },
    created() {
        const rememberedEmail = localStorage.getItem("rememberMyEmail");
        if (rememberedEmail) {
            this.email = rememberedEmail;
            this.rememberMe = true;
        }
    },
    mounted() {
        if (this.rememberMe) {
            this.$refs.emailInput.validate();
        }
    },
    methods: {
        ...mapActions("user", {
            logInUser: "login",
        }),
        async login() {
            try {
                this.loading = true;
                await this.logInUser({ email: this.email, password: this.password });
                if (this.rememberMe) {
                    localStorage.setItem("rememberMyEmail", this.email);
                } else {
                    localStorage.removeItem("rememberMyEmail");
                }
                await this.$router.push("/");
            } catch (e) {
                if (e && e.response && e.response.status === 401) {
                    this.$toasted.error(this.$t("Login.badCredentials"), { icon: "lock" });
                    this.password = "";
                    this.$nextTick(() => {
                        this.$refs.formObserver.validate();
                    });
                }
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">

    #login {
        display: block;
        transform: translateY(25%);
        opacity: 0;
        animation: slide-from-bottom 0.5s forwards;
        /*transition: all 5s ease;*/
        /*opacity: 0;*/
    }

    .card-body {
        max-width: 420px;
        min-width: 400px;
    }

</style>